import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus'
import ContactUs from './contact-us';

const ctaBarBottom = () => {
    const ctaBar = document.querySelectorAll('.persistent-cta--bottom');

    let ctaBarConstructor = (id) => {
        Vue.component('cta-bar-bottom-template', {
            data: function() {
                return {
                    isSticky: false,
                    isMobile: store.state.isMobile,
                    scrolled: false,
                    isFinalPosition: false,
                    observer: null,
                    contactOpen: false,
                    store: store
                }
            },
            computed: {
                computedIsMobile: function() {
                    return store.state.isMobile;
                }
            },
            watch: {
                computedIsMobile: function() {
                      if (this.computedIsMobile == true) {
                        this.initShow();
                        this.detectFooter();
                        this.isMobile = true;
    
                        EventBus.$on('stick-nav', () => {
                            this.stickyNav();
                            this.isSticky = true;
                        });
                        EventBus.$on('unstick-nav', () => {
                            if (!this.isFinalPosition) {
                                this.unstickyNav();
                                this.isSticky = false;
                            } else { return; }
                        });
                      } else {
                          this.isMobile = false;
                        EventBus.$off('stick-nav');
                        EventBus.$off('unstick-nav');
                        document.querySelector('.persistent-cta--bottom-final').classList.remove('active');
                        this.unstickyNav();
                        document.querySelector('.persistent-cta--bottom').style.display = "none";

                        let target = document.querySelector('.footer');
                        this.observer.disconnect(target);
                      }
                  },
                // isSticky: function() {
                //     this.contactOpen = this.isSticky ? this.contactOpen : false; 
                // }
            },
            methods: {
                toggleContact() {
                    this.contactOpen = !this.contactOpen;
                },
                stickyNav() {
                    if (!this.$el.parentNode.classList.contains('active') && !this.isSticky && this.computedIsMobile) {
                        this.$el.parentNode.classList.add("active");
                    } 
                },
                unstickyNav() {
                    if (this.isSticky) {
                        this.$el.parentNode.classList.remove("active");
                    }
                },
                initShow() {
                    // show bottom after 3 seconds
                    setTimeout(() => {
                        this.$el.parentNode.classList.add('active');
                    }, 3000);
                },
                detectFooter() {
                    let options= {
                        root: null,
                        rootMargin: '0px',
                        threshold: 0
                    }
                    const handleSticky = (changes) => {
                        changes.forEach(change => {
                            if (!(change.intersectionRatio > 0)) {
                                this.isFinalPosition = false;
                                // hide due ai chat icon visibility
                                document.querySelector('.persistent-cta--bottom').style.display = 'none';
                            } else {
                                this.isFinalPosition = true;
                                document.querySelector('.persistent-cta--bottom').style.display = 'none';
                            }
                        })
                    }
                    let observer = new IntersectionObserver(handleSticky, options);
                    this.observer = observer;
                    let target = document.querySelector('.footer');

                    observer.observe(target);
                }
            },
            mounted() {
                EventBus.$on('stick-nav', () => {
                    this.stickyNav();
                    this.isSticky = true;
                    this.scrolled = true;
                });
                EventBus.$on('unstick-nav', () => {
                    if (!this.isFinalPosition) {
                        this.unstickyNav();
                        this.isSticky = false;
                        this.scrolled = true;
                    } else { return; }
                });
                EventBus.$on('close-contact', () => {
                    this.contactOpen = false;
                });
                if (this.isMobile) {
                    this.initShow();
                    this.detectFooter();
                }
            }
        });

        ContactUs();

        new Vue({
            el: `.persistent-cta--bottom-${id}`,
            store: store,
        }).$mount(`.persistent-cta--bottom-${id}`, true);
    }

    if (ctaBar.length > 0) {
        ctaBar.forEach((item, index) => {
            item.classList.add(`persistent-cta--bottom-${index}`);
            ctaBarConstructor(index);
        })
    }

}

export default ctaBarBottom;